import React from 'react'
import Scrollchor from 'react-scrollchor'
// import { StickyContainer, Sticky } from 'react-sticky'
import Banner from './Banner'

const Header = () =>
    <div className="container-fluid p-0 vh-100 header-wrap">
        <div className="row no-gutters h-100">
            <div className="col-12 col-md-8 offset-md-4 h-100">
                <div className="headercontent fade-in1 h-100">
                    <div className="headerwrap">
                        <h1>
                            <img src="img/logo.png" alt="Kano - Hoodies All Summer" title="Kano - Hoodies All Summer" className="logo fade-in1" />
                        </h1>
                        <a
                            href="https://shop.kanomusic.com"
                            className="merch-link"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Merch
                            <img
                                className="merch-link__arrow"
                                src="img/downarrow.png"
                                alt="Arrow"
                            />
                        </a>
                    </div>
                    <div className="photomobile">
                        <img src="img/background_mobile2.jpg" className="photomobile__img" alt="Kano" />
                        {/* <Banner
                            text="Order the album from shop.kanomusic.com for priority access to tour tickets*"
                        /> */}
                    </div>
                    <div className="dividerline_mob"></div>
                    <Scrollchor
                        className="anchor watchnow"
                        to="#watchnow"
                        disableHistory={true}
                        // animate={{ offset: window.innerWidth < 768 ? 0 : 70 }}
                    >
                        <div onClick={() => {
                            if (window.s_gi && window.s_dtm) {
                                let s = s_gi('wmg,wmggbglobal,wmgprl,wmgprlgb,wmgkanomusic.com')
                                s_dtm.linkTrackVars='prop1,eVar4'
                                s_dtm.prop1 = 'Kano'
                                s_dtm.eVar4 = 'Kano'
                                s_dtm.tl(this, 'o', 'Kano:Hoodies All Summer Pre-order:Landing:Watch Now Navigation Click')
                            }
                        }}>
                            <h3>
                                <img className="watchnow__text" src="img/watchnow.png" alt="Watch Now" title="Watch Now" />
                            </h3>
                            <img
                                className="watchnow__arrow"
                                src="img/downarrow.png"
                                alt="Down arrow"
                            />
                        </div>
                    </Scrollchor>
                </div>
            </div>
            <div className="col-12">
                <div className="dividerline u-t-0" />
            </div>
        </div>
    </div>

export default Header
